<template>
  <div class="new-customer">
    <div class="columns is-multiline">
      <div class="column is-12">
        <BField
          label="Nombre de cliente"
          label-for="privateName"
        >
          <BInput
            id="privateName"
            v-model="privateName"
            placeholder="Rafaeli Camposorio Ruízo"
            icon="account"
            :disabled="true"
            :loading="loading"
          />
        </BField>
      </div>

      <div class="column is-12">
        <BField
          label="Email"
          label-for="privateEmail"
        >
          <BInput
            id="privateEmail"
            v-model="privateEmail"
            placeholder="correo@mail.com"
            icon="email"
            type="email"
            :disabled="true"
            :loading="loading"
          />
        </BField>
      </div>

      <div class="column is-12">
        <BField
          label="RFC"
          label-for="privateRfc"
        >
          <BInput
            id="privateRfc"
            v-model="privateRfc"
            placeholder="PAL7202161U0"
            icon="fingerprint"
            :pattern="rfcPattern"
            :disabled="true"
            :loading="loading"
          />
        </BField>
      </div>
      <div class="column is-12">
        <BField
          label="Razón social"
          label-for="privateCompanyName"
        >
          <BInput
            id="privateCompanyName"
            v-model="privateCompanyName"
            placeholder="Machete SA de CV"
            icon="domain"
            :disabled="true"
            :loading="loading"
          />
        </BField>
      </div>

      <div class="column is-12">
        <BField
          label="Días de crédito"
          label-for="privateCreditDays"
        >
          <BInput
            id="privateCreditDays"
            v-model="privateCreditDays"
            placeholder="30"
            icon="bank"
            :disabled="true"
            :loading="loading"
          />
        </BField>
      </div>

      <div class="column is-12">
        <BField
          label="Limite de crédito"
          label-for="privateCreditLimit"
        >
          <BInput
            id="privateCreditLimit"
            v-model="privateCreditLimit"
            placeholder="30"
            icon="bank"
            :disabled="true"
            :loading="loading"
          />
        </BField>
        <p class="help">
          {{ privateCreditLimit | toCurrency('MXN') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewCustomer',

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      privateName: this.$store.state.customers.temporal.name,
      privateCreditDays: this.$store.state.customers.temporal.creditDays,
      privateEmail: this.$store.state.customers.temporal.email,
      privateRfc: this.$store.state.customers.temporal.rfc,
      privateCompanyName: this.$store.state.customers.temporal.companyName,
      privateCreditLimit: this.$store.state.customers.temporal.creditLimit,
      rfcPattern: '^[A-Z&Ñ]{3,4}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2}[0-9A]$',
    };
  },

  beforeDestroy() {
    this.$store.commit('customers/setValues', {
      name: '',
      email: '',
      rfc: '',
      companyName: '',
      creditDays: 0,
    });
  },

  methods: {
    onInput(name, event) {
      this.$store.commit('customers/setValue', { accessor: name, value: event });
    },
  },
};
</script>

<style scoped>
@media screen and (min-width: 769px) {
  .new-customer {
    max-width: 100%;
  }
}
</style>
